export class FormatInfo {
	constructor(period = "yearly", decimals = 2, format = true, signMode = "normal") {
		this.period = period;
		this.decimals = decimals;
		this.format = format;
		this.signMode = signMode;
	}
}

export function formatValue2(formatInfo, amount) {

	if (formatInfo.period == "monthly") amount /= 12;
	if (formatInfo.period == "weekly") amount /= 52;
	if (formatInfo.period == "daily") amount /= (52 * 5);

	if (!formatInfo.format) return amount;

	return formatNumber(amount, formatInfo.decimals, formatInfo.signMode);
}

export function formatValue(period, amount, decimals = 2, format = true, signMode = "normal") {
	let info = new FormatInfo(period, decimals, format, signMode);
	return formatValue2(info, amount);
}

export function formatNumber(amount, decimals = 2, signMode = "normal") {
	const options = {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals
	};
	const formatted = Number(amount).toLocaleString('en', options);

	if (signMode == "compact")
		return "£" + formatted;
	else if (signMode == "normal")
		return "£ " + formatted;
	else if (signMode == "none")
		return formatted;
}